import Vue from 'vue';
import Colcade from 'colcade';
import { initReveal } from '../modules/reveals';

Vue.component('team-listing', {
    data() {
        return {
            team: [],
            colc: null,
        };
    },

    props: {
        initialTeam: {
            type: Array,
        },
    },

    mounted() {
        // TODO check if it can work without timeout, improve onresize
        setTimeout(() => {
            this.initColcade();
        }, 500);

        this.initTeam();

        EventBus.$on('window-resize', () => {
            this.initTeam();
            this.initColcade();
        });
    },

    methods: {
        loadMore() {
            // load more members
        },

        initTeam() {
            this.team = this.initialTeam;
        },

        initColcade() {
            const grid = document.querySelector('.grid');

            this.colc = new Colcade(grid, {
                columns: '.grid-col',
                items: '.grid-item',
            });

            setTimeout(() => {
                initReveal();
            }, 200);
        },
    },
});
